import { Button } from '@/components/ui/button'
import { Copy, Trash2, X } from 'lucide-react'
import { TreeNode } from '@/hooks/useHierarchy'

interface BulkOperationsToolbarMobileProps {
  selectionStatus: {
    selectedCount: number
    hasSelection: boolean
  }
  selectedNodes: TreeNode[]
  onBulkClone: () => void
  onBulkDelete: () => void
  onClearSelection: () => void
}

export const BulkOperationsToolbarMobile = ({
  selectionStatus,
  onBulkClone,
  onBulkDelete,
  onClearSelection,
}: BulkOperationsToolbarMobileProps) => {
  if (!selectionStatus.hasSelection) return null

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-background border-t border-border p-4 z-50"
      style={{ paddingBottom: 'calc(1rem + env(safe-area-inset-bottom))' }}
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold">
            {selectionStatus.selectedCount} items selected
          </p>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            className="h-8 w-8 p-0"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            className="flex-1 h-12 pointer-coarse:h-14"
            onClick={onBulkClone}
          >
            <Copy className="h-4 w-4 mr-2" />
            Clone
          </Button>
          <Button
            variant="destructive"
            className="flex-1 h-12 pointer-coarse:h-14"
            onClick={onBulkDelete}
          >
            <Trash2 className="h-4 w-4 mr-2" />
            Delete
          </Button>
        </div>
      </div>
    </div>
  )
}
